<script>
import Layout from '@layouts/main';
import CarForm from '@views/cars/form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  name: 'CarEdit',
  components: {
    Layout,
    CarForm,
  },
  mixins: [beforeLeaveAfterEdit],
  page() {
    return {
      title: `${this.$t('titles.edit_car')} #${this.$route.params.id}`,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.cars'),
          to: { name: 'cars.index' },
        },
        {
          text: `${this.$t('titles.edit_car')} #${this.$route.params.id}`,
          active: true,
        },
      ],
    };
  },
  methods: {
    update(callback) {
      this.setUnchanged();
      if (!callback) {
        this.$router.push({
          name: 'cars.index',
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.edit_car')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <CarForm :loaded-id="$route.params.id" @submitted="update" @entity-changed="initBeforeLeave" />
    </b-card>
  </Layout>
</template>
